import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <div className="home-page">
      <Header />
      <main className="home-main">
        <div className="home-container">
          <div className="home-hero">
            <h1 className="home-title">
              <span className="title-rose">Rose</span>Learn.me
            </h1>
            <p className="home-description">
              Платформа для онлайн обучения с интерактивными уроками и видеосвязью.
            </p>
            {!isAuthenticated && (
              <div className="home-buttons">
                <button 
                  onClick={() => navigate('/login')}
                  className="btn-login"
                >
                  Вход
                </button>
              </div>
            )}
            {isAuthenticated && (
              <div className="home-buttons">
                <button 
                  onClick={() => navigate('/dashboard')}
                  className="btn-register btn-primary"
                >
                  Перейти в личный кабинет
                </button>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
